/**
 * Generates an item list name by combining a cleaned template name and a formatted title.
 *
 * @param {string} templateName - The template name.
 * @param {string} title - The title to be formatted.
 * @returns {string} The combined and formatted item list name.
 */
export function getItemListName(templateName, title) {
    const cleanTemplateName = templateName.split('-light-module:').pop();
    const formattedTitle = title.trim().replace(/\s+/g, '-');

    return `${cleanTemplateName}_${formattedTitle}`;
}
